import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import EmpifyQuoteAndAttribution from 'src/app/organisms/Homepage/EmpifyQuoteAndAttribution/EmpifyQuoteAndAttribution';

const EmpifyTestimonial = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
  >
    <Stack justify='center'>
      <EmpifyQuoteAndAttribution />
    </Stack>
  </SectionLayout>
);

export default EmpifyTestimonial;
